import { useAppSelector } from 'root/src/client/logic/helpers/useStore';
import isAdminSelector from 'root/src/client/logic/auth/selectors/isAdminSelector';
export const useIsAdmin = () => {
    return useAppSelector(isAdminSelector);
};
